/* SAOTO — Le Rituel de Préparation : cadran scrollytelling.
   Améliore progressivement le balisage statique (grille centrée
   desktop / timeline verticale mobile, toujours visible sans JS) :
   - desktop (>= 990px) : cadran sticky scrollytelling ;
   - mobile/tablette (< 990px) : reveal doux au scroll (IntersectionObserver) ;
   - prefers-reduced-motion: reduce -> aucune amélioration n'est appliquée,
     la composition statique reste affichée telle quelle. */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 990px)';
  var MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function addMqlListener(mql, fn) {
    if (mql.addEventListener) {
      mql.addEventListener('change', fn);
    } else if (mql.addListener) {
      mql.addListener(fn);
    }
  }

  function removeMqlListener(mql, fn) {
    if (mql.removeEventListener) {
      mql.removeEventListener('change', fn);
    } else if (mql.removeListener) {
      mql.removeListener(fn);
    }
  }

  function initRitualDial(root) {
    if (root.ritualDialInstance) {
      root.ritualDialInstance.destroy();
    }

    var stage = root.querySelector('[data-ritual-stage]');
    var sticky = root.querySelector('[data-ritual-sticky]');
    var ring = root.querySelector('[data-ritual-ring]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ritual-step]'));

    if (!stage || !sticky || !steps.length) { return; }

    var desktopMql = window.matchMedia(DESKTOP_QUERY);
    var motionMql = window.matchMedia(MOTION_QUERY);

    var mode = null; // 'dial' | 'timeline' | null
    var ticking = false;
    var activeIndex = -1;
    var io = null;
    var ringCircumference = 0;

    if (ring && ring.r && ring.r.baseVal) {
      ringCircumference = 2 * Math.PI * ring.r.baseVal.value;
      ring.style.strokeDasharray = String(ringCircumference);
      ring.style.strokeDashoffset = String(ringCircumference);
    }

    function setActive(index) {
      if (index === activeIndex) { return; }
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === index);
        step.classList.toggle('is-leaving', i === activeIndex && i !== index);
      });
      activeIndex = index;
    }

    function updateRingProgress(fraction) {
      if (!ring || !ringCircumference) { return; }
      ring.style.strokeDashoffset = String(ringCircumference * (1 - fraction));
    }

    function computeDialProgress() {
      ticking = false;
      var rect = stage.getBoundingClientRect();
      var viewportH = window.innerHeight;
      var total = rect.height - viewportH;

      if (rect.top > 0) {
        sticky.classList.remove('is-pinned', 'is-released');
      } else if (rect.bottom <= viewportH) {
        sticky.classList.remove('is-pinned');
        sticky.classList.add('is-released');
      } else {
        sticky.classList.remove('is-released');
        sticky.classList.add('is-pinned');
      }

      if (total <= 0) {
        setActive(0);
        updateRingProgress(0);
        return;
      }

      var fraction = -rect.top / total;
      if (fraction < 0) { fraction = 0; }
      if (fraction > 1) { fraction = 1; }

      var count = steps.length;
      var index = Math.min(count - 1, Math.floor(fraction * count));

      setActive(index);
      updateRingProgress(fraction);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(computeDialProgress);
      }
    }

    function enableDialMode() {
      mode = 'dial';
      root.classList.add('is-enhanced');
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      computeDialProgress();
    }

    function disableDialMode() {
      root.classList.remove('is-enhanced');
      sticky.classList.remove('is-pinned', 'is-released');
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      steps.forEach(function (step) {
        step.classList.remove('is-active', 'is-leaving');
      });
      activeIndex = -1;
    }

    function enableTimelineMode() {
      mode = 'timeline';
      if (!('IntersectionObserver' in window)) { return; }

      root.classList.add('is-reveal-ready');
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
      );
      steps.forEach(function (step) { io.observe(step); });
    }

    function disableTimelineMode() {
      root.classList.remove('is-reveal-ready');
      if (io) {
        io.disconnect();
        io = null;
      }
      steps.forEach(function (step) {
        step.classList.remove('is-revealed');
      });
    }

    function teardown() {
      if (mode === 'dial') { disableDialMode(); }
      if (mode === 'timeline') { disableTimelineMode(); }
      mode = null;
    }

    function evaluate() {
      var shouldEnhance = !motionMql.matches;
      var wantsDial = shouldEnhance && desktopMql.matches;
      var wantsTimeline = shouldEnhance && !desktopMql.matches;

      if (wantsDial && mode !== 'dial') {
        teardown();
        enableDialMode();
      } else if (wantsTimeline && mode !== 'timeline') {
        teardown();
        enableTimelineMode();
      } else if (!shouldEnhance && mode !== null) {
        teardown();
      }
    }

    function onPreferenceChange() { evaluate(); }

    addMqlListener(desktopMql, onPreferenceChange);
    addMqlListener(motionMql, onPreferenceChange);

    evaluate();

    root.ritualDialInstance = {
      destroy: function () {
        teardown();
        removeMqlListener(desktopMql, onPreferenceChange);
        removeMqlListener(motionMql, onPreferenceChange);
        root.ritualDialInstance = null;
      }
    };
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll ? container.querySelectorAll('[data-ritual-dial]') : [];
    Array.prototype.forEach.call(roots, initRitualDial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-ritual-dial]')
      : null;
    if (root && root.ritualDialInstance) {
      root.ritualDialInstance.destroy();
    }
  });
})();
